// @flow
import i18n from "i18next";
import k from "src/i18n/keys";
import React from "react";

import * as R from "ramda";
import { Text } from "@unifize/sarah";

import * as colors from "src/styles/constants/colors";
import FormName from "src/components/Form/Name";

import FieldContent from "../Content/FieldContent";
import { FormContent } from "./styles";

type Props = {
  forms: Object,
  timestamp: string,
  invertColors?: boolean,
};

const Forms = ({ forms, timestamp, invertColors = false }: Props) => {
  const formIds = R.keys(forms);

  return (
    <>
      {formIds.map((formId) => {
        const form = forms[formId];
        const formFields = form.fields ? Object.keys(form.fields) : [];
        return (
          formFields.length > 0 && (
            <FormContent invertBackground={invertColors}>
              <Text weight="bold" color={colors.grey39} variant="caption">
                <FormName id={form.templateId} />{" "}
                {form.address && <>({form.address})</>}
              </Text>
              <FieldContent
                fields={formFields}
                timestamp={timestamp}
                data={form}
                form
              />
            </FormContent>
          )
        );
      })}
    </>
  );
};

export default Forms;
